import apiClient from './api.service';

const CleanupService = {
  // Teachers with no course that has ever had a registration
  getTeachersWithoutRegistrations() {
    return apiClient.get('/admin/cleanup/teachers-without-registrations');
  },
  deleteTeachers(userIds) {
    return apiClient.post('/admin/cleanup/teachers-without-registrations', { userIds });
  },

  // Courses with no registrations, or past their end date
  getCoursesEligibleForDeletion() {
    return apiClient.get('/admin/cleanup/courses');
  },
  deleteCourses(courseIds) {
    return apiClient.post('/admin/cleanup/courses', { courseIds });
  },

  // Students with no active (paid) registration
  getStudentsWithoutActiveCourse() {
    return apiClient.get('/admin/cleanup/students-without-active-course');
  },
  deleteStudents(userIds) {
    return apiClient.post('/admin/cleanup/students-without-active-course', { userIds });
  }
};

export default CleanupService;
